import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * The delivery time picker on the delivery catering modal needs to be empty by default. The accompanying date picker is not empty
 * and the two pickers use the same date-time string. This is a problem because the time picker would normally have a value and
 * the user could accidentally submit an order without specifying a time. This deliveryTimeSelected boolean is used to detect
 * if the user has manually set a delivery time.
 */
const slice = createSlice({
  name: 'deliveryTimeSelected',
  initialState: false,
  reducers: {
    setDeliveryTimeSelected(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setDeliveryTimeSelected } = slice.actions;

export default slice.reducer;
